import { BasemapId } from '../types';

export interface BasemapConfig {
  id: BasemapId;
  name: string;
  url: string;
  attribution: string;
  maxZoom?: number;
}

const DEFAULT_OSM_URL = (process.env.REACT_APP_OPENFREEMAP_URL || '').trim() ||
  'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png';

export const BASEMAP_CONFIG: Record<BasemapId, BasemapConfig> = {
  osm: {
    id: 'osm',
    name: 'OpenStreetMap',
    url: DEFAULT_OSM_URL,
    attribution: '&copy; OpenStreetMap contributors',
    maxZoom: 19,
  },
  'osm-hot': {
    id: 'osm-hot',
    name: 'OSM Humanitarian',
    url: 'https://{s}.tile.openstreetmap.fr/hot/{z}/{x}/{y}.png',
    attribution:
      '&copy; OpenStreetMap contributors, Tiles style by Humanitarian OpenStreetMap Team hosted by OpenStreetMap France',
    maxZoom: 19,
  },
  satellite: {
    id: 'satellite',
    name: 'Satellite',
    url: 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}',
    attribution:
      'Tiles &copy; Esri — Source: Esri, i-cubed, USDA, USGS, AEX, GeoEye, Getmapping, Aerogrid, IGN, IGP, UPR-EGP, and the GIS User Community',
    maxZoom: 19,
  },
  cyclosm: {
    id: 'cyclosm',
    name: 'Cycling (CyclOSM)',
    url: 'https://{s}.tile-cyclosm.openstreetmap.fr/cyclosm/{z}/{x}/{y}.png',
    attribution:
      'Map data &copy; OpenStreetMap contributors | Tiles style &copy; CyclOSM, hosted by OSM France',
    maxZoom: 20,
  },
  topo: {
    id: 'topo',
    name: 'Topographic',
    url: 'https://{s}.tile.opentopomap.org/{z}/{x}/{y}.png',
    attribution:
      'Map data: &copy; OpenStreetMap contributors, SRTM | Map style: &copy; OpenTopoMap (CC-BY-SA)',
    maxZoom: 17,
  },
  'carto-light': {
    id: 'carto-light',
    name: 'Carto Light',
    url: 'https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png',
    attribution:
      '&copy; OpenStreetMap contributors &copy; CARTO',
    maxZoom: 20,
  },
  'carto-dark': {
    id: 'carto-dark',
    name: 'Carto Dark',
    url: 'https://{s}.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}{r}.png',
    attribution:
      '&copy; OpenStreetMap contributors &copy; CARTO',
    maxZoom: 20,
  },
  'carto-voyager': {
    id: 'carto-voyager',
    name: 'Carto Voyager',
    url: 'https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png',
    attribution:
      '&copy; OpenStreetMap contributors &copy; CARTO',
    maxZoom: 20,
  },
};

export const BASEMAP_OPTIONS: BasemapConfig[] = Object.values(BASEMAP_CONFIG);

export const DEFAULT_BASEMAP: BasemapId = 'osm';
